
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { getSportsListSubscriptionRequest } from "../../../helpers/terminalRequests/virtualSportsHelpers";
import { createSelector } from 'reselect';
import PropTypes from "prop-types";
import Helpers from "../../../helpers/helperFunctions";
import { UIMixin } from '../../../mixins/uiMixin';
import { TOGGLE_VIRTUAL_KEYBOARD } from "../../../actions/actionTypes";
import { withRouter } from "react-router";

class VirtualGamesSportList extends Component {
    constructor (props) {
        super(props);
        this.state = {};
        this.selectSport = this.selectSport.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick (e) {
        this.props.dispatch({ type: TOGGLE_VIRTUAL_KEYBOARD, payload: false });
        e.preventDefault();
    }
    selectSport (selectedSportId) {
        return () => {
            this.setState({
                selectedSportId
            });
        };
    }
    componentDidMount() {
        this.props.data?.map(sport => this.props.params.sportAlias === sport.alias && this.setState({
            selectedSportId: sport.id
        }));
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        (!this.state.selectedSportId && nextProps.data && nextProps.data.length !== 0) && this.setState({selectedSportId: nextProps.data[0].id});
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

VirtualGamesSportList.propTypes = {
    selectedProvider: PropTypes.string,
    setProvider: PropTypes.func,
    data: PropTypes.array,
    loaded: PropTypes.bool
};

const mapStateToProps = (state, ownParams) => {
    let key = getSwarmDataKeyForRequest(getSportsListSubscriptionRequest(ownParams.selectedProvider));
    return createSelector(
        [
            state => state.swarmData.loaded[key],
            state => state.swarmData.data[key] && JSON.stringify(Helpers.objectToArray(state.swarmData.data[key].sport)),
            state => state.uiState.showVirtualKeyboard
        ],
        (loaded, data, showVirtualKeyboard) => {
            data = data && JSON.parse(data);
            return {
                data,
                loaded,
                showVirtualKeyboard
            };
        }
    );
};

export default withRouter(connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: UIMixin({Component: VirtualGamesSportList}),
        ComponentWillMount: function () {
            let {selectedProvider} = this.props;
            this.swarmSubscriptionRequest = getSportsListSubscriptionRequest(selectedProvider);
            this.swarmDataKey = getSwarmDataKeyForRequest(getSportsListSubscriptionRequest(selectedProvider));
        }
    }
)));